import { IAnalyticsRepositoryParams, IAnalyticsRepository } from "@/core/repositories/analytics";


export class GetAnalyticsScoreCardsUseCase {
    constructor(private readonly repo: IAnalyticsRepository) {}

    async execute(params: IAnalyticsRepositoryParams) {
        return this.repo.getAnalyticsScoreCards(params);
    }
}